export const GRAPHQL_API =
  process.env.REACT_APP_GRAPHQL_API ?? 'https://calc.basis-opora.ru/graphql/';

export const HOST_API = process.env.REACT_APP_GRAPHQL_API ?? 'https://calc.basis-opora.ru/storage/';
export const HOST_API_PROD =
  process.env.REACT_APP_GRAPHQL_API ?? 'https://calc.basis-opora.ru/storage/projects/';

export const BLOCK = 'Блокировать?';
export const RESTORE = 'Восстановить?';

export const RESTORE_USER_TITLE = 'Восстановить пользователя?';
export const BLOCK_USER_TITLE = 'Блокировать пользователя?';

export const PRINT_IMPOSSIBLE = 'Нет расчета, печать невозможна';
export const PRINT_POSSIBLE = 'Печать pdf доступна';
export const NEW_PROJECT = 'Новый проект';

export const NEED_VALID_EMAIL = 'Нужен валидный email';
export const IS_REQUIRED = 'Не должно быть пустым';
export const MIN_LONG = 'Как минимум 8 символов';
export const WRONG_EMAIL_OR_PASSWORD = 'Неверный пароль или email';
export const MUST_BE_LATIN_LETTER = 'Должна быть хоть одна латинская буква в пароле';
export const ONLY_JPG = 'Поддерживается только формат JPG';

export const STORAGE_SAVE_SECTOR = {
  Sector: 'sector',
};

export const STORAGE_SAVE_USER_ID = {
  UserId: 'userId',
};

export const STORAGE_SAVE = {
  UserId: 'userId',
};
